/*
 * "Laes mere" under den korte produkttekst: aabner Beskrivelse-harmonikaen
 * laengere nede og ruller derhen. Teksten staar kun ét sted.
 *
 * 29/9 (Nicolai: "er du sikker paa den altid ruller ned til toppen af
 * beskrivelsen?"): scrollIntoView med block 'center' centrerede boksen, og da
 * den er hoejere end skaermen, landede man midt i teksten. Maalt 12 af 12
 * gange paa mobil og desktop: toppen stod 22 til 703 px under den faste
 * header. Nu rulles toppen af boksen til lige under headeren.
 *
 * To faelder fundet paa /en og .se: (1) klikker man helt oeverst paa siden,
 * staar topbjaelken over headeren, saa headerens underkant er 141 og ikke de
 * 118, den fylder naar den sidder fast. Derfor regnes med headerens hoejde.
 * (2) En scrollend fra foer rulningen gik i gang kom med det samme og brugte
 * efterretningen op. Den ignoreres nu, til siden faktisk har flyttet sig.
 */
(function () {
  'use strict';

  var knap = document.querySelector('.nt-kortbesk__mere');
  if (!knap) return;

  var LUFT = 12;

  /* Pladsen den faste header fylder oeverst, naar vi har rullet ned */
  function headerHoejde() {
    var h = document.querySelector('store-header');
    if (!h || h.dataset.isSticky !== 'true') return 0;
    return h.getBoundingClientRect().height;
  }

  function maalTop(maal) {
    return Math.max(0, window.scrollY + maal.getBoundingClientRect().top - headerHoejde() - LUFT);
  }

  knap.addEventListener('click', function () {
    var blok = document.querySelector('.product-info__block--description details, .product-info .disclosure');
    if (!blok) return;
    if (blok.tagName === 'DETAILS') blok.open = true;
    else {
      var indre = blok.querySelector('details') || blok.closest('details');
      if (indre) indre.open = true;
    }

    var maal = blok.closest('.product-info__block--description') || blok;
    var start = window.scrollY;
    window.scrollTo({ top: maalTop(maal), behavior: 'smooth' });

    /* Ret efter, naar rulningen er faerdig: billeder ovenover kan have flyttet siden */
    var faerdig = false;
    function ret(tvungen) {
      if (faerdig) return;
      var y = maalTop(maal);
      if (!tvungen && Math.abs(window.scrollY - start) < 2 && Math.abs(y - window.scrollY) > 4) return;
      faerdig = true;
      window.removeEventListener('scrollend', paaScrollend);
      if (Math.abs(y - window.scrollY) > 4) window.scrollTo({ top: y, behavior: 'smooth' });
    }
    function paaScrollend() { ret(false); }
    window.addEventListener('scrollend', paaScrollend);
    setTimeout(function () { ret(true); }, 1500);
  });
})();
